import gql from 'graphql-tag';
import backgroundImg from '../assets/landing/backgroundImg.png';
import aboutImg from '../assets/landing/about.png';
import programImg from '../assets/landing/program.png';
import supportImg from '../assets/landing/support.png';
import exploreImg from '../assets/landing/explore.png';
import redBubble from '../assets/landing/red_button.png';
import yellowBubble from '../assets/landing/yellow_button.png';
import purpleBubble from '../assets/landing/purple-button.png';
import trek from '../assets/landing/trek.png';
import NCICommunity from '../assets/landing/NCICommunity.svg';
import AvailableOutputs from '../assets/landing/AvailableOutputs.svg';
import UpdatedMetrics from '../assets/landing/UpdatedMetrics.svg';
import arrowCommunity from '../assets/landing/arrow-community.svg';
import arrowOutputs from '../assets/landing/arrow-outputs.svg';
import arrowMetrics from '../assets/landing/arrow-metrics.svg';
import heroExploreButtonArrow from '../assets/landing/heroExploreButtonArrow.svg';

export const STAT_VISUALS_BY_API = {
  numberOfPrograms: {
    desktopGradient: 'linear-gradient(to right, #c56e6e, #923b3c)',
    mobileColor: 'linear-gradient(to top, #c34f54, #e26063)',
  },
  numberOfResources: {
    desktopGradient: 'linear-gradient(to right, #fabe5f, #EDA534)',
    mobileColor: 'linear-gradient(to top, #c98619, #EDA534)',
  },
  numberOfDatasets: {
    desktopGradient: 'linear-gradient(to right, #7297ed, #4f72c9)',
    mobileColor: 'linear-gradient(to top, #5074ca, #6488E5)',
  },
  numberOfProjects: {
    desktopGradient: 'linear-gradient(to right, #aabbff, #7788cc)',
    mobileColor: 'linear-gradient(to top, #7f8ad4, #9DA9F9)',
  },
  numberOfGrants: {
    desktopGradient: 'linear-gradient(to right, #be73d6, #8b40a3)',
    mobileColor: 'linear-gradient(to top, #8b40a3, #B06DCE)',
  },
  numberOfPublications: {
    desktopGradient: 'linear-gradient(to right, #e6a0df, #c56ec2)',
    mobileColor: 'linear-gradient(to top, #c56ec2, #e6a0df)',
  },
};

// The ideal image size of landingPageHero 1400x600px
// Tile1 Tile2 Tile3 images 293x349 px
// Tile4 image optimum size 600x 436 px
export const landingPageData = {
  callToActionTitle: 'Landscape Analysis of NCI-Supported Projects & Associated Outputs',
  callToActionDescription: 'A comprehensive index of programs funded by the National Cancer Institute, devoted to transparency and accuracy of fund allocation and interconnectedness of data output. This pilot phase of the site is temporarily limited to data generated through extramural grants from two NCI programs.',
  callToActionButtonText: 'INS PROGRAMS',
  callToActionLink: '/programs',
  callToActionButtonText2: 'INS DATASETS',
  callToActionLink2: '/datasets',
  nciCommunityTitle: 'NCI Community',
  nciCommunityDescription: 'INS finds NCI programs and projects',
  nciCommunityLink: '/programs',
  availableOutputsTitle: 'Available Outputs',
  availableOutputsDescription: 'INS finds publicly shared outputs',
  availableOutputsLink: '/programs',
  updatedMetricsTitle: 'Updated Metrics',
  updatedMetricsDescription: 'View metrics on shared data',
  updatedMetricsLink: '/programs',
  landingPageHero: {
    alt: 'background',
    img: backgroundImg,
  },
  interactiveImg: {
    alt: 'Interactive INS features diagram',
    img: trek,
  },
  NCICommunityBubble: {
    alt: 'Red indicator bubble',
    img: redBubble,
  },
  AvailableOutputsBubble: {
    alt: 'Yellow indicator bubble',
    img: yellowBubble,
  },
  UpdatedMetricsBubble: {
    alt: 'Purple indicator bubble',
    img: purpleBubble,
  },
  NCICommunityImg: {
    alt: '3 circles icon',
    img: NCICommunity,
  },
  AvailableOutputsImg: {
    alt: 'Horizontal bar graph icon',
    img: AvailableOutputs,
  },
  UpdatedMetricsImg: {
    alt: 'Donut chart icon',
    img: UpdatedMetrics,
  },
  arrowCommunityImg: {
    alt: 'Arrow connecting to 3 circles icon',
    img: arrowCommunity,
  },
  arrowOutputsImg: {
    alt: 'Arrow connecting to Horizontal bar graph icon',
    img: arrowOutputs,
  },
  arrowMetricsImg: {
    alt: 'Arrow connecting to Donut chart icon',
    img: arrowMetrics,
  },
  heroExploreButtonArrow: {
    alt: 'button arrow',
    img: heroExploreButtonArrow,
  },
  landingPageStatsBar: [
    {
      statTitle: 'Programs',
      statAPI: 'numberOfPrograms',
    },
    {
      statTitle: 'Resources',
      statAPI: 'numberOfResources',
    },
    {
      statTitle: 'Datasets',
      statAPI: 'numberOfDatasets',
    },
    {
      statTitle: 'Projects',
      statAPI: 'numberOfProjects',
    },
    {
      statTitle: 'Grants',
      statAPI: 'numberOfGrants',
    },
    {
      statTitle: 'Publications',
      statAPI: 'numberOfPublications',
    },
  ],
  tile1: {
    alt: 'file cabinets with one drawer open with several file folders',
    img: aboutImg,
    titleText: 'ABOUT THE INDEX OF NCI STUDIES',
    descriptionText: 'The goal of the Index of NCI Studies (INS) is to enable access to information about the large amount of data generated by NCI-supported studies so that NCI leadership, cancer researchers, and the public can rapidly assess the state of science at a single location.',
    callToActionText: 'Read More',
    callToActionLink: '/about',
  },
  tile2: {
    alt: 'abstract depiction of a strand of DNA',
    img: programImg,
    titleText: 'PROGRAMS',
    descriptionText: 'Provides a list of programs currently included in the site.',
    callToActionText: 'Visit programs listing',
    callToActionLink: '/programs',
  },
  tile3: {
    alt: 'Laptop displaying NCI website',
    img: supportImg,
    titleText: 'INS SUPPORT',
    descriptionText: 'For questions or feedback, please contact INS support.',
    callToActionText: 'Contact INS',
  },
  tile4: {
    alt: 'Cancer patient with abstract data displayed in front of her.',
    img: exploreImg,
    titleText: 'INS DATA GATHERING',
    descriptionText: 'The INS data gathering pipeline uses both expert curation and automated processes to connect programs and studies to research outputs.',
    callToActionText: 'Learn more',
    callToActionLink: '/about',
  },
};

// --------------- GraphQL query - Retrieve Landing page data --------------
export const GET_LANDING_PAGE_DATA_QUERY = gql`{
  numberOfPrograms
  numberOfResources
  numberOfDatasets
  numberOfProjects
  numberOfGrants
  numberOfPublications
}
  `;
